export default {
  main: {
    '@media print': {
      display: 'none',
    },
  },
}
